import state from './moduleDistributorState.js'
import mutations from './moduleDistributorMutations.js'
import actions from './moduleDistributorActions.js'
import getters from './moduleDistributorGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

